import { Fragment } from 'react';

import { Dialog, DialogContent } from '@/components/ui/dialog';

import { AddRepresentative, EditRepresentative, RemoveRepresentativeModal } from './';

import { useRepresentative } from '../model';

const actionComponentMap = {
  add: AddRepresentative,
  edit: EditRepresentative,
};

const RepresentativeModalActions = () => {
  const { action, setInitialData } = useRepresentative();

  const ActionComponent =
    action && action in actionComponentMap ? actionComponentMap[action as keyof typeof actionComponentMap] : null;

  return (
    <Fragment>
      <Dialog open={action === 'add' || action === 'edit'} onOpenChange={setInitialData}>
        <DialogContent className="md:max-w-[374px] sm:max-w-[374px]">
          {ActionComponent && <ActionComponent />}
        </DialogContent>
      </Dialog>

      <RemoveRepresentativeModal />
    </Fragment>
  );
};

export default RepresentativeModalActions;
